module.exports = __webpack_public_path__ + "media/src/assets/Images/PlusWhite-696ba9a1bb6fc45c74142871eb86016b.svg";